/**
 * Adapt data into contact format
 *
 * 1. Transform checkbox boolean values into readable format
 */export function adaptDataForContact(formData){return transformCheckboxesInReadableFormat(formData)}/**
 * Transform checkboxes in readable format
 */export function transformCheckboxesInReadableFormat(formData){for(let name in formData){let value=formData[name];(1===value||0===value)&&(formData[name]=value?"true":"false")}return formData}